import {
  NoticeAnalysisByGroupGroupBy,
  NoticeAnalysisByPeriodGroupBy,
} from "../../lib/types/graphQLEnums";
import { ExportNoticesButton } from "../notices/ExportNoticesButton";
import { NoticeFilters } from "../notices/utils";
import { DropdownMenuItem } from "../ui/dropdown_menu";

type NoticeAnalysisExportButtonProps = {
  filters: NoticeFilters;
  selectedRows: string[];
  groupBy: NoticeAnalysisByGroupGroupBy | NoticeAnalysisByPeriodGroupBy;
};

export const NoticeAnalysisExportButton = ({
  filters,
  selectedRows,
  groupBy,
}: NoticeAnalysisExportButtonProps) => {
  return (
    <ExportNoticesButton
      filters={addSelectedRowsToFilters({ filters, selectedRows, groupBy })}
      extraDropdownItems={[
        <DropdownMenuItem key="print" onClick={triggerPrint}>
          Export to PDF
        </DropdownMenuItem>,
      ]}
    />
  );
};

export const addSelectedRowsToFilters = ({
  filters,
  selectedRows,
  groupBy,
}: NoticeAnalysisExportButtonProps): NoticeFilters => {
  if (selectedRows.length === 0) {
    return filters;
  }

  if (groupBy === NoticeAnalysisByGroupGroupBy.Buyer) {
    return {
      ...filters,
      buyers: selectedRows,
      buyerListIds: [],
    };
  }
  if (groupBy === NoticeAnalysisByGroupGroupBy.Supplier) {
    return {
      ...filters,
      supplierGuids: selectedRows,
      suppliers: [],
    };
  }
  // Unsupported groupBy, so just return the original filters
  return filters;
};

const triggerPrint = () => {
  // Safari doesn't support window.print() correctly, so have to use execCommand
  // Problem is it doesn't open until ALL requests have completed, which won't happen due to analytics, gql subscriptions, etc.
  // https://stackoverflow.com/a/72818375
  try {
    if (!document.execCommand("print")) {
      window.print();
    }
  } catch {
    window.print();
  }
};
